import { render } from "./InteligentLearning.vue?vue&type=template&id=29dd5b85&scoped=true"
import script from "./InteligentLearning.vue?vue&type=script&lang=js"
export * from "./InteligentLearning.vue?vue&type=script&lang=js"

import "./InteligentLearning.vue?vue&type=style&index=0&id=29dd5b85&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dd5b85"]])

export default __exports__